import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: false,
            refetchOnWindowFocus: false,
            staleTime: 1 * 60 * 60 * 1000,
            placeholderData: (prevData) => prevData
        },
    },
});